import { Box, Flex, Text, Icon, IconButton } from '@chakra-ui/react';
import {
  MdHelp as HelpIcon,
  MdLogout as LogoutIcon,
  MdPerson as PersonIcon,
  MdGroup as HouseholdIcon,
} from 'react-icons/md';
import { useLocation } from 'wouter';
import { useAuth } from '@/hooks/useAuth';
import { useChatContext } from '@/hooks/useChatContext';
import { ROUTES } from '@/types';

export default function DesktopSidebarProfile() {
  const { user, logout } = useAuth();
  const [, navigate] = useLocation();
  const { openChat } = useChatContext();

  return (
    <Box
      borderTop="1px solid"
      borderColor="border.muted"
      pt={3}
      mt={2}
      px={3}
      pb={4}
    >
      {/* Household link */}
      <Flex
        as="button"
        align="center"
        gap={2}
        w="100%"
        px={1}
        py="7px"
        borderRadius="7px"
        color="text.primary"
        fontFamily="body"
        fontWeight="400"
        fontSize="12.5px"
        cursor="pointer"
        textAlign="left"
        transition="background 0.12s"
        _hover={{ bg: 'bg.muted' }}
        onClick={() => navigate(ROUTES.HOUSEHOLD())}
      >
        <Icon as={HouseholdIcon} boxSize={4} color="text.muted" flexShrink={0} />
        <Text flex={1}>Household</Text>
      </Flex>

      {/* Divider */}
      <Box h="1px" bg="border.muted" my={2} />

      {/* Avatar + name/email + inline Help + Logout */}
      <Flex align="center" gap={2}>
        {/* Avatar */}
        <Box
          w="28px"
          h="28px"
          borderRadius="full"
          bg="accent.secondary"
          border="1px solid"
          borderColor="accent.secondaryBorder"
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflow="hidden"
          flexShrink={0}
        >
          {user?.picture ? (
            <img
              src={user.picture}
              alt={user.name ?? 'Profile'}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <Icon as={PersonIcon} boxSize={3.5} color="white" />
          )}
        </Box>

        {/* Name + email */}
        <Box flex={1} minW={0}>
          {user?.name && (
            <Text
              fontFamily="body"
              fontWeight="600"
              fontSize="12px"
              color="text.primary"
              truncate
              lineHeight="1.3"
            >
              {user.name}
            </Text>
          )}
          {user?.email && (
            <Text
              fontFamily="body"
              fontWeight="300"
              fontSize="11px"
              color="text.muted"
              truncate
              lineHeight="1.3"
            >
              {user.email}
            </Text>
          )}
        </Box>

        {/* Help + Logout icon buttons */}
        <Flex gap={0} flexShrink={0}>
          <IconButton
            aria-label="Help"
            size="xs"
            variant="ghost"
            color="text.muted"
            onClick={() => openChat({ helpMode: true, recipeId: null, collectionId: null })}
            _hover={{ bg: 'bg.muted', color: 'text.primary' }}
          >
            <HelpIcon size={15} />
          </IconButton>
          <IconButton
            aria-label="Sign out"
            size="xs"
            variant="ghost"
            color="accent.emphasis"
            onClick={() => logout()}
            _hover={{ bg: 'bg.muted' }}
          >
            <LogoutIcon size={15} />
          </IconButton>
        </Flex>
      </Flex>
    </Box>
  );
}
